module.exports = __webpack_public_path__ + "img/图片1.dfb0b6a4.png";